import {useWatch} from 'react-hook-form'
import {useOrderProcessFormContext} from '../../form/useOrderProcessFormContext'
import {Contact, PhoneNumber} from '../../types'

export const useOrderPlacer = () => {
  const {control, setValue, trigger, formState: {defaultValues}} = useOrderProcessFormContext()
  const [name, phoneNumber] = useWatch({
    name: ['orderPlacer.name', 'orderPlacer.phoneNumber'],
    control
  })
  const { name: defaultName, phoneNumber: defaultPhoneNumber } = defaultValues?.orderPlacer ?? {}

  const setOrderPlacerName = (name: string) => {
    setValue('orderPlacer.name', name, {shouldValidate: true})
    trigger()
  }

  const setOrderPlacerPhoneNumber = (phoneNumber: PhoneNumber) => {
    setValue('orderPlacer.phoneNumber', phoneNumber, {shouldValidate: true})
    trigger()
  }

  const setOrderPlacer = (orderPlacer: Contact) => {
    setValue('orderPlacer', orderPlacer, {shouldValidate: true})
    trigger()
  }

  return {
    name,
    phoneNumber,
    defaultName,
    defaultPhoneNumber,
    setOrderPlacerName,
    setOrderPlacerPhoneNumber,
    setOrderPlacer
  }
}
